import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './Marketplace.css';

const categories = ['全部', '数码电子', '家具家居', '母婴儿童', '文体乐器'];

export default function Secondhand() {
  const { language, translatePhrase } = useLanguage();
  const text = language === 'zh' ? {
    kicker: '二手商品 · 社区补充模块',
    title: '浏览附近闲置好物',
    subtitle: '二手商品保留位置搜索、分类筛选、商品详情和聊天咨询能力，但不影响技能服务的主定位。',
    publish: '发布商品',
    services: '技能服务',
    servicesDesc: '服务者主动发布，可咨询预约',
    tasks: '需求广场',
    tasksDesc: '发布需求，等待服务者报价',
    secondhand: '二手商品',
    secondhandDesc: '社区闲置流转补充入口',
    search: '搜索耳机、办公椅、乐器...',
    allCategories: '全部分类',
    backServices: '回到技能服务',
    negotiable: '可议价',
    fixed: '不议价',
    seller: '卖家',
    loading: '正在加载已发布商品...',
    empty: '暂无已发布商品。真实商品审核通过后会显示在这里。',
  } : {
    kicker: 'Secondhand · Community add-on',
    title: 'Browse nearby pre-owned goods',
    subtitle: 'Secondhand keeps location search, category filters, item details, and chat inquiries without changing the main focus on skill services.',
    publish: 'Post item',
    services: 'Skill services',
    servicesDesc: 'Providers publish services for consultation and booking',
    tasks: 'Requirement marketplace',
    tasksDesc: 'Post requirements and wait for provider quotes',
    secondhand: 'Secondhand',
    secondhandDesc: 'Community circulation for idle items',
    search: 'Search headphones, office chairs, instruments...',
    allCategories: 'All categories',
    backServices: 'Back to services',
    negotiable: 'Negotiable',
    fixed: 'Fixed price',
    seller: 'Seller',
    loading: 'Loading published items...',
    empty: 'No published items yet. Approved real items will appear here.',
  };
  const [keyword, setKeyword] = useState('');
  const [category, setCategory] = useState('全部');
  const [liveItems, setLiveItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const page = 1;
    setLoading(true);
    api.get('/marketplace/products', {
      params: {
        keyword,
        category,
        page,
        limit: 12,
      },
    })
      .then(res => {
        const products = res.data.products || [];
        setLiveItems(products.map(item => ({ ...item, id: `listing-${item.id}`, liveId: item.id })));
      })
      .catch(() => {
        setLiveItems([]);
      })
      .finally(() => setLoading(false));
  }, [keyword, category]);

  return (
    <div className="market-page">
      <section className="market-hero">
        <div className="container">
          <div className="market-hero-row">
            <div>
              <div className="market-kicker">{text.kicker}</div>
              <h1>{text.title}</h1>
              <p>{text.subtitle}</p>
            </div>
            <Link className="btn btn-primary" to="/secondhand/new">{text.publish}</Link>
          </div>
          <div className="market-tabs">
            <Link className="market-tab" to="/services"><strong>{text.services}</strong><span>{text.servicesDesc}</span></Link>
            <Link className="market-tab" to="/tasks"><strong>{text.tasks}</strong><span>{text.tasksDesc}</span></Link>
            <Link className="market-tab active" to="/secondhand"><strong>{text.secondhand}</strong><span>{text.secondhandDesc}</span></Link>
          </div>
        </div>
      </section>

      <section className="market-toolbar">
        <div className="container market-toolbar-grid">
          <form className="market-search" onSubmit={e => e.preventDefault()}>
            <span>🔍</span>
            <input value={keyword} onChange={e => setKeyword(e.target.value)} placeholder={text.search} />
          </form>
          <select className="market-select" value={category} onChange={e => setCategory(e.target.value)}>
            {categories.map(c => <option key={c} value={c}>{c === '全部' ? text.allCategories : translatePhrase(c)}</option>)}
          </select>
          <Link className="btn btn-outline" to="/services">{text.backServices}</Link>
        </div>
      </section>

      <main className="container market-content">
        <div className="goods-grid">
          {loading && <div className="market-empty">{text.loading}</div>}
          {!loading && liveItems.map(item => (
            <Link key={item.id} to={`/secondhand/${item.id}`} className="goods-card">
              <div className="card-meta">
                <span className="pill">{translatePhrase(item.category)}</span>
                <span className="pill">{translatePhrase(item.condition)}</span>
                <span className="pill">{item.distance}</span>
              </div>
              <h3>{translatePhrase(item.title)}</h3>
              <p className="card-muted">{translatePhrase(item.summary)}</p>
              <div className="price-line">
                <span className="price">{item.price}</span>
                <span className="card-muted">{item.negotiable ? text.negotiable : text.fixed}</span>
              </div>
              <div className="card-muted">{translatePhrase(item.area)} · {text.seller} {translatePhrase(item.seller)}</div>
            </Link>
          ))}
          {!loading && liveItems.length === 0 && <div className="market-empty">{text.empty}</div>}
        </div>
      </main>
    </div>
  );
}
